import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useTheme } from '../contexts/ThemeContext';
import YearSection from './YearSection';

const TimelineContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const VerticalTimeline = ({ predictions, onPredictionClick }) => {
  const { themeData } = useTheme();
  // Group predictions by year
  const predictionsByYear = predictions.reduce((acc, prediction) => {
    const year = prediction.display_year;
    if (!acc[year]) {
      acc[year] = [];
    }
    acc[year].push(prediction);
    return acc;
  }, {});

  // Get sorted years
  const years = Object.keys(predictionsByYear)
    .map(year => parseInt(year))
    .sort((a, b) => a - b);

  if (years.length === 0) {
    return (
      <TimelineContainer>
        <div style={{ 
          textAlign: 'center', 
          color: themeData.colors.textSecondary, 
          padding: '4rem 0',
          fontSize: '1.1rem'
        }}>
          No predictions match your current filters.
        </div>
      </TimelineContainer>
    );
  }

  return (
    <TimelineContainer>
      {years.map(year => (
        <YearSection
          key={year}
          year={year}
          predictions={predictionsByYear[year]}
          onPredictionClick={onPredictionClick}
        />
      ))}
    </TimelineContainer>
  );
};

VerticalTimeline.propTypes = {
  predictions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    display_year: PropTypes.number.isRequired
  })).isRequired,
  onPredictionClick: PropTypes.func.isRequired
};

export default VerticalTimeline; 